import { ListBoxSection, type ListBoxSectionProps } from 'react-aria-components';
import { type ListBoxProps, ListBox as _ListBox } from './list-box';
import { ListBoxItem, type ListBoxItemProps } from './list-box.item';

const ListBox = Object.assign(_ListBox, {
  Item: ListBoxItem,
  Section: ListBoxSection,
});

export type { ListBoxItemProps, ListBoxProps, ListBoxSectionProps };
export { ListBox };
